import { render, staticRenderFns } from "./ChatMedia.vue?vue&type=template&id=65a6f64a&scoped=true"
import script from "./ChatMedia.vue?vue&type=script&lang=ts"
export * from "./ChatMedia.vue?vue&type=script&lang=ts"
import style0 from "./ChatMedia.vue?vue&type=style&index=0&id=65a6f64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6f64a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VDialog,VIcon,VImg,VListItem,VListItemContent,VListItemSubtitle})
